class VariantCollectionSort extends HTMLElement {
  constructor() {
    super();
    this.productsList = document.getElementById('ProductsList');
    this.sortSelect = this.querySelector('select');
    
    if (this.productsList && this.sortSelect) {
      this.init();
    }
  }
  
  init() {
    this.sortSelect.addEventListener('change', () => this.handleSort());
    this.applySortFromURL();
  }
  
  handleSort() {
    const sortBy = this.sortSelect.value;
    const productColumns = Array.from(this.productsList.querySelectorAll('.product-column'));
    
    productColumns.sort((a, b) => {
      const priceA = parseFloat(a.dataset.variantPrice);
      const priceB = parseFloat(b.dataset.variantPrice);
      const titleA = a.dataset.variantTitle.toLowerCase();
      const titleB = b.dataset.variantTitle.toLowerCase();
      
      switch(sortBy) {
        case 'price-ascending':
          return priceA - priceB;
        case 'price-descending':
          return priceB - priceA;
        case 'title-ascending':
          return titleA.localeCompare(titleB);
        case 'title-descending':
          return titleB.localeCompare(titleA);
        default:
          return 0;
      }
    });
    
    productColumns.forEach(column => {
      this.productsList.appendChild(column);
    });
    
    this.updateURL(sortBy);
  }
  
  updateURL(sortBy) {
    const url = new URL(window.location);
    if (sortBy) {
      url.searchParams.set('sort_by', sortBy);
    } else {
      url.searchParams.delete('sort_by');
    }
    window.history.pushState({}, '', url);
  }
  
  applySortFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortParam = urlParams.get('sort_by');
    if (sortParam && this.sortSelect.value !== sortParam) {
      this.sortSelect.value = sortParam;
      this.handleSort();
    }
  }
}

customElements.define('variant-collection-sort', VariantCollectionSort);